export default __webpack_public_path__ + "static/media/Zimmer_Biomet_logo.a150cbe0.svg";